/**
 * CustomFormInput component script class
 *
 * @package    Common
 * @author     Ihor Anishchenko <ianischenko@mindk.com>
 * @copyright  Copyright (c) 2010-2018 MindK (http://mindk.com). All rights reserved.
 * @license    http://mindk.com
 * @link       http://mindk.com
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { FormattedMessage } from 'react-intl';
import InputLabel from '@material-ui/core/InputLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import CustomInput from 'Common/CustomInput/CustomInput';
import InputAdornment from '@material-ui/core/InputAdornment';
import LockOutline from '@material-ui/icons/Lock';
import Email from '@material-ui/icons/Email';

import RequiredMark from 'Common/Form/RequiredMark';

import { childrenType } from 'Types';

import styles from './styles.js';

@withStyles(styles)
export default class CustomFormInput extends Component {
    /**
     * @type {Object}
     */
    static propTypes = {
        children: childrenType,
        input: PropTypes.any,
        label: PropTypes.string,
        type: PropTypes.string,
        meta: PropTypes.object,
        className: PropTypes.string,
        rowClassName: PropTypes.string,
        withLabel: PropTypes.bool,
        maxLength: PropTypes.number,
        classes: PropTypes.object,
        placeholder: PropTypes.string,
        required: PropTypes.bool,
        disabled: PropTypes.bool,
        errorText: PropTypes.string,
        additionalLabel: PropTypes.object
    };

    /**
     * @type {Object}
     */
    static defaultProps = {
        withLabel: false,
        additionalLabel: null
    };

    /**
     * @type {Object}
     */
    static contextTypes = {
        intl: PropTypes.object.isRequired,
    };

    render() {
        const {
            input,
            label,
            meta: { touched, error, form },
            withLabel,
            rowClassName,
            children,
            classes,
            maxLength,
            type,
            placeholder,
            required,
            disabled,
            errorText,
            additionalLabel
        } = this.props;

        let id = `${form}-${input.name}-field`,
            message = error,
            placeholders = {};

        if (Array.isArray(message)) {
            [message, placeholders] = message;
        }

        let errorMessage = /validation.error.\w+/.test(message)
            ? this.context.intl.formatMessage({ id: message }, placeholders)
            : message;

        return (
            <div className={rowClassName}>
                {withLabel && (
                    <InputLabel htmlFor={id} error={error && touched}>
                        <FormattedMessage id={`field.${label}.label`} />
                        {required ? <RequiredMark /> : ''}
                    </InputLabel>
                )}

                { additionalLabel }

                <CustomInput
                    formControlProps={{
                        fullWidth: true,
                        className: classes.customFormControlClasses,
                        error: error && touched,
                    }}
                    inputProps={{
                        ...input,
                        inputProps: { maxLength },
                        type: type,
                        startAdornment: (
                            <InputAdornment position="start" className={classes.inputAdornment}>
                                {type === 'password' && <LockOutline className={classes.inputAdornmentIcon} />}
                                {type === 'email' && <Email className={classes.inputAdornmentIcon} />}
                            </InputAdornment>
                        ),
                        placeholder: placeholder ? this.context.intl.formatMessage({ id: `field.${placeholder}.placeholder` }) : '',
                        disabled
                    }}
                />

                {children}

                {(touched || errorText) &&
                    (error || errorText) && (
                        <FormHelperText error={(error && touched) || !!(errorText && errorText.length)} className="errors-list">
                            {errorText ? this.context.intl.formatMessage({ id: errorText }) : errorMessage}
                        </FormHelperText>
                    )}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/common/Form/CustomFormInput.jsx